module.exports = __webpack_public_path__ + "static/img/a011.c1fd6ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a011.jpg
// module id = 0PES
// module chunks = 0